import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { PodcastIntroTile, PodcastType } from './PodcastIntroTile'

export interface PodcastIntroTileRegistrationProps {
    podcast: PodcastType
    title: string
    description: string
    releaseDay?: string
}

export const PodcastIntroTileRegistration = createRegisterableComponent(
    'podcast-intro-tile',
    (
        {
            podcast,
            title,
            description,
            releaseDay,
        }: PodcastIntroTileRegistrationProps,
        services,
    ) => {
        const shareUrl = services.config.publicUrl + services.location.pathname
        return (
            <PodcastIntroTile
                podcast={podcast}
                title={title}
                description={description}
                releaseDay={releaseDay}
                shareUrl={shareUrl}
                onEvent={services.onEvent}
            />
        )
    },
)
